import { render, staticRenderFns } from "./Ringkasan.vue?vue&type=template&id=342b0f06"
import script from "./Ringkasan.vue?vue&type=script&lang=js"
export * from "./Ringkasan.vue?vue&type=script&lang=js"
import style0 from "./Ringkasan.vue?vue&type=style&index=0&id=342b0f06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports